module.exports = {
    // AUTOMATED TRIGGER DO NOT REMOVE THIS LINE
    bc: {
        // Brand Colors
        1: '#D7007F', // ADA Rubine
        2: '#524FA1', // Benaroya
        3: '#008081', // Sea Foam
        4: '#74777A', // Medium Gray
        5: '#939598', // Silver Tone
        6: '#DCDDDE', // Light Gray
        7: '#FF30AB', // Rubine Highlight
        8: '#46C1BE', // Sea Foam Highlight
        9: '#46438A', // Dark Benaroya
        10: '#A90064', // Dark Rubine
        11: '#F3F3F3', // Ghost
        12: '#000000', // Black
        13: '#8ED9F9', // Global Blue Alert
        14: '#FAC4C9', // Special Notice Alert
        15: '#FFCB05', // Geometric Yellow
        16: '#F180C3', // Transparent Rubine
        17: '#4B46D3', // Benaroya Highlight
        18: '#E40087', // Rubine
        19: '#6C7073', // Metal
        20: '#333333', // Dark Gray
        21: '#4B46D3', // Teal
        22: '#692B2C', // Pantone 7629C
        23: '#7C2E53', // Pantone 74-15 C
        24: '#682745', // Pantone 229 C
        25: '#BC9312', // Pantone 12-0748 TPG
        26: '#00000000',
        27: '#00000000',
        28: '#00000000',
        29: '#00000000',
        30: '#00000000',
        31: '#00000000',
        32: '#00000000',
        33: '#00000000',
        34: '#00000000',
        35: '#00000000',
        // Utility Colors
        36: '#000001', // Black
        37: '#ffffff', // White
        38: '#f3f3f3', // Gray-1
        39: '#e6e6e6', // Gray-2
        40: '#cccccc', // Gray-3
        41: '#b3b3b3', // Gray-4
        42: '#999999', // Gray-5
        43: '#808080', // Gray-6
        44: '#666667', // Gray-7
        45: '#4d4d4d', // Gray-8
        46: '#333333', // Gray-9
        47: '#1a1a1a', // Gray-10
        48: '#ff0000', // Red
        49: '#ff7f00', // Orange
        50: '#ffff00', // Yellow
        51: '#00ff00', // Green
        52: '#0000ff', // Blue
        53: '#4b0082', // Indigo
        54: '#9400d3', // Violet
        55: '#00000000',
        56: '#00000000',
        57: '#00000000',
        58: '#00000000',
        59: '#00000000',
        60: '#00000000',
        61: '#00000000',
        62: '#00000000',
        63: '#00000000',
        64: '#00000000',
        65: '#00000000',
        66: '#00000000',
        67: '#00000000',
        68: '#00000000',
        69: '#00000000',
        70: '#00000000',
    },
};
